import { NgClass, NgForOf, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { SharedDirectivesModule } from '@app/shared/shared-directives.module';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'adspt-ratio-tag',
  templateUrl: './ratio-tag.component.html',
  styleUrls: ['./ratio-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NzTagModule, NgIf, NgClass, NgForOf, SharedDirectivesModule, NzToolTipModule],
})
export class RatioTagComponent {
  @Input() ratio: number;

  @Input() settings = {
    warning: 0,
    success: 0.9,
    perfect: 0.95,
  };

  @Input()
  tooltip?: string;

  protected get tagClass(): string {
    if (this.ratio < this.settings.warning) {
      return 'adspt-tag-red-line';
    } else if (this.ratio < this.settings.success) {
      return 'adspt-tag-alert-line';
    } else {
      return 'adspt-tag-success-line';
    }
  }

  protected get checks(): number[] {
    return [
      ...(this.ratio >= this.settings.warning ? [1] : []),
      ...(this.ratio >= this.settings.success ? [2] : []),
      ...(this.ratio >= this.settings.perfect ? [3] : []),
    ];
  }
}
